module.exports = __webpack_public_path__ + "static/media/team-1.7c26478a.jpg";